var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var NotificationGlobalContainer = function (_React$Component) {
  _inherits(NotificationGlobalContainer, _React$Component);

  function NotificationGlobalContainer() {
    _classCallCheck(this, NotificationGlobalContainer);

    return _possibleConstructorReturn(this, (NotificationGlobalContainer.__proto__ || Object.getPrototypeOf(NotificationGlobalContainer)).apply(this, arguments));
  }

  _createClass(NotificationGlobalContainer, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cf-notifications__global_container' },
        this.props.children
      );
    }
  }]);

  return NotificationGlobalContainer;
}(React.Component);

NotificationGlobalContainer.propTypes = {
  children: PropTypes.node
};

export default NotificationGlobalContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-notifications/es/NotificationGlobalContainer.js
// module id = 664
// module chunks = 0